import EfScrollAni from '@/efscrollani';
import Detail from './detail';
import styles from './index.module.scss';
import { useProductStore } from './ProductProvider';

export default function ExampleProductA() {
    const { pageStatus } = useProductStore();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return (
        <div className={styles.page}>
            <Detail />
        </div>
    );
}
